import * as React from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import downloadIcon from 'svg/download-icon.svg'
import { DownloadProps } from 'types'

export default function DownloadImages({ handleDownPNG, handleDownJPG, handleDownPDF }: Readonly<DownloadProps>) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleDownloadPNG = () => {
    handleClose()
    handleDownPNG()
  }
  const handleDownloadJPG = () => {
    handleClose()
    handleDownJPG()
  }
  const handleDownloadPDF = () => {
    handleClose()
    handleDownPDF()
  }

  return (
    <div>
      <Button
        sx={{
          width: '34px',
          height: '34px',
          minWidth: '30px',
          padding: '0px',
          borderRadius: '6px',
          position: 'absolute',
          right: '24px',
          top: '24px',
          zIndex: 19,
          backgroundColor: 'rgba(200, 200, 200, 0.35)',
          '&:hover': {
            backgroundColor: 'rgba(200, 200, 200, 0.7)',
          },
        }}
        id='download-button'
        aria-controls={open ? 'download-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <img width={24} height={24} src={downloadIcon} alt='download' />
      </Button>
      <Menu
        id='download-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PopoverClasses={{ paper: 'download-menu-dropdown-popover' }}
        MenuListProps={{
          'aria-labelledby': 'download-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleDownloadPNG}>Download PNG image</MenuItem>
        <MenuItem onClick={handleDownloadJPG}>Download JPG image</MenuItem>
        <MenuItem onClick={handleDownloadPDF}>Download PDF document</MenuItem>
      </Menu>
    </div>
  )
}
